import { IProductRow } from "./iproduct-row.interface";
import { IBriefProduct } from "../../../../../../types/product/ibrief-product/ibrief-product.interface";
import { IProductDetail } from "../../../../../../types/product/iproduct-detail.interface";

export const getProductRowPrice = (product: IProductRow) => {
  if (product.price === null || isNaN(Number(product.price))) {
    return "";
  }
  return product.price.toFixed(2);
};

export function mapSearchResultsToProductRow(
  searchResults: IProductDetail[],
  briefProducts: IBriefProduct[]
): IProductRow[] {
  if (!searchResults) {
    return [];
  }

  return searchResults.map((productResult: IProductDetail) => ({
    ...productResult,
    selected: briefProductsHaveProduct(productResult, briefProducts),
  }));
}

const briefProductsHaveProduct = (
  product: IProductDetail,
  briefProducts: IBriefProduct[]
): boolean =>
  briefProducts.some((briefProduct: IBriefProduct) => briefProduct.productDetail.id === product.id);
